package com.milta.core.localization.translations.fr

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Quota d'optimisations atteint",
    exhaustedCreateRouteMessage = "Retour le {date}. Vous pouvez créer la tournée sans optimisation : l'ordre saisi est conservé.",
    exhaustedCreateBatchMessage = "Retour à {limit} optimisations le {date}. Le lot peut être créé sans optimisation : l'ordre saisi est conservé.",
    quotaReachedResetOn = "Quota d'optimisations atteint — remise à zéro le {date}",
    routeCreatedInEnteredOrder = "Tournée créée dans l'ordre saisi.",
    routeWillBeCreatedInEnteredOrder = "La tournée sera créée dans l'ordre saisi.",
    batchCreatedInEnteredOrder = "Le lot a été créé sans optimisation, dans l'ordre saisi.",
    sendWithoutOptimization = "Envoyer sans optimisation",
    batchNotOptimizedTitle = "Lot créé sans optimisation",
    batchNotOptimizedMessage = "Quota d'optimisations atteint. L'ordre actuel des arrêts est conservé.",
    batchNotOptimizedMobileMessage = "Lot créé sans optimisation : quota d'optimisations atteint. Ordre saisi conservé, répartition équitable par nombre de stops.",
    reoptimizeAction = "Ré-optimiser",
    reoptimizeUnavailableWeb = "Ré-optimisation indisponible : quota atteint, retour le {date}. L'ordre actuel est conservé et l'envoi reste possible.",
    reoptimizeUnavailableMobile = "Ré-optimisation indisponible jusqu'au {date} (quota atteint). L'envoi reste possible.",
    stopAddedAtEndTitle = "Arrêt ajouté en fin de tournée",
    stopAddedAtEndMessage = "Quota d'optimisations atteint — remise à zéro le {date}. L'ordre des autres arrêts ne change pas.",
    reoptimizeExhaustedHint = "Quota d'optimisations atteint, retour le {date}",
    myOptimizationsTitle = "Mes optimisations",
    remainingForPeriod = "Restant pour la période",
    remainingSuffix = "restantes",
    resetLabel = "Remise à zéro",
    resetAtRenewal = "Au renouvellement de l'abonnement",
    driverExplanation = "Revient à zéro au renouvellement de votre abonnement. Chauffeur d'une Entreprise : votre compteur suit l'abonnement de l'Entreprise, avec la limite essai tant qu'elle est en essai.",
    enterpriseExplanation = "Revient à zéro au renouvellement de votre abonnement. Ce compteur ne concerne que vos optimisations ; chaque chauffeur a le sien.",
    webCounterNotice = "Ce compteur ne concerne que les optimisations lancées par ce compte. Chaque chauffeur a le sien, visible dans son app.",
    historyTitle = "Historique",
    columnDate = "Date",
    columnAction = "Action",
    columnTarget = "Tournée concernée",
    columnOutcome = "Résultat",
    actionOptimizeRoute = "Optimiser une tournée",
    actionCreateRouteBatch = "Créer un lot",
    actionReoptimizeRouteBatch = "Ré-optimiser un lot",
    actionReoptimizeOnStopAdded = "Ré-optimiser à l'ajout d'un arrêt",
    actionReoptimizeInPlace = "Ré-optimiser sur place",
    actionCreateOwnRoute = "Créer ma tournée",
    outcomeCounted = "Comptée",
    outcomeRefunded = "Rendue",
    outcomeRefundedLong = "Rendue — échec RoutaR",
    refundedNotCounted = "échec RoutaR, non décomptée",
    targetRoute = "Tournée du {date}",
    targetBatch = "Lot du {date}",
    historyLoadingMore = "Chargement des lignes suivantes…",
    historyEnd = "Fin de l'historique — {count} lignes",
    historyEmpty = "Aucune optimisation sur cette période.",
    historyLoadError = "Impossible de charger l'historique.",
    retryAction = "Réessayer",
    loading = "Chargement…",
    errorNoConnection = "Impossible de contacter le serveur — vérifiez votre connexion.",
    errorGeneric = "Une erreur est survenue. Réessayez plus tard.",
    tabOptimizations = "Optimisations RoutaR",
    tabAiTokens = "Tokens IA",
    comingSoon = "À venir",
    limitsDescription = "Nombre d'optimisations RoutaR autorisées par compte et par période d'abonnement, selon le type de compte et le statut de l'abonnement. Le compteur de chaque compte revient à zéro au renouvellement de son abonnement.",
    columnTrial = "Essai",
    columnPaid = "Payant",
    rowEnterprise = "Compte Entreprise",
    rowDriver = "Chauffeur",
    fieldRequired = "Champ obligatoire.",
    fieldMustBePositive = "Doit être supérieur à 0.",
    limitsFootnote = "Valeurs exprimées en optimisations par période. Un chauffeur d'Entreprise reçoit la limite « Chauffeur », en essai tant que son Entreprise est en essai, sinon payant.",
    limitsSaved = "Limites enregistrées. Entreprise : {enterpriseTrial} essai · {enterprisePaid} payant. Chauffeur : {driverTrial} essai · {driverPaid} payant.",
    limitsRejected = "Valeurs refusées : chaque limite doit être supérieure à 0.",
    saveAction = "Enregistrer",
    detailsAction = "Détails",
    accountDetailsTitle = "Détails de l'utilisateur",
    sectionIdentity = "Identité",
    accountTypeLabel = "Type de compte",
    kindEnterpriseOwner = "Compte Entreprise",
    kindEnterpriseDriver = "Chauffeur d'Entreprise",
    kindIndependentDriver = "Chauffeur indépendant",
    withoutOrganisation = "Sans organisation",
    subscriptionLabel = "Abonnement",
    viaOrganisation = "Via organisation",
    subscriptionTrial = "Essai",
    subscriptionPaid = "Payant",
    appliedLimitLabel = "Limite appliquée",
    limitKindEnterprise = "Limite Compte Entreprise",
    limitKindDriver = "Limite Chauffeur",
    enterpriseInTrialSuffix = "(l'Entreprise est en essai)",
    resetSourceOwn = "Renouvellement de l'abonnement",
    resetSourceEnterprise = "Renouvellement de {enterprise}",
    exhaustedBadge = "Quota épuisé",
    manuallyAdjustedBadge = "Remplacé manuellement",
    replaceLabel = "Remplacer le nombre restant",
    replaceAction = "Remplacer",
    replaceHelp = "Pour la période en cours uniquement. À la remise à zéro, le compte repart de la limite globale.",
    replaceHelpEnterpriseDriver = "Ne modifie que le compteur de {name}. Celui de l'Entreprise et des autres chauffeurs ne change pas.",
    replaceInvalid = "Saisissez un nombre supérieur ou égal à 0.",
    replaceRejected = "Valeur refusée par le serveur.",
    replaceMaximum = "Maximum 100 000.",
    replacedBanner = "Nombre restant remplacé : {from} → {to}. Pour la période en cours. Le {date}, retour à la limite globale ({limit}).",
    adminHistoryTitle = "Historique des optimisations",
    accountNotFound = "Compte introuvable.",
)
